<div class="container-fluid brands-cont" >

    <!--    <owl-carousel-o *ngIf="brands.length > 0;" [options]="customOptions" >-->

    <div class="container">
        <h5 class="mb-4 mt-4 title " i18n>Our trusted brands</h5>

        <div class="row">
            <div *ngFor="let brand of brands"  >

                <div [routerLink]="'/search/'+brand.keywords" class="brand-block" id="{{brand.name}}" (mouseover)="hoverAnim($event,brand)" (mouseleave)="hoverOutAnim($event,brand)" >
                    <img class="img-fluid" src="assets/brands/{{brand.image}}" width="150"  />
                </div>
            </div>
        </div>
    </div>
    <!--        </ng-template>-->

    <!--    </owl-carousel-o>-->



</div>
